module.exports = __webpack_public_path__ + "./assets/airbaselogo.929f20.png";


//////////////////
// WEBPACK FOOTER
// ./app/imgs/airbaselogo.png
// module id = 2
// module chunks = 1